export default "__VITE_ASSET__CvKRPfIx__"